import React, {useEffect, useState, useRef} from "react";
import PropTypes from 'prop-types';
import { Button } from "react-bootstrap";
import { Translate } from "../Translator.jsx";
import PdfPng from '../../Assets/Pdf.png';
import { ConfigurationApiBlobSasUri } from "../../ExternalApi/ConfigurationApi.js"
import { IsEmptyString, UploadFileWithProgress } from "../GeneralFunctions.jsx"

//This datasource will work with the cloud-only DatasourceBlobFile

const DatasourceCsvFileExport = (props) => {
    
    const [mRepainter, SetRepainter] = useState(false);
    const [mError, SetError] = useState("")
    const [mProgressMessage, SetProgressMessage] = useState("")
    const [mFilename, SetFilename] = useState(Translate("No file chosen"));

    const mFileInputRef = useRef(null)

    useEffect(() => {
        SetReady()
      }, []); 
      
    const UpdateDatasourceSetting = (aIdentifier, aValue) =>
    {
        SetRepainter(!mRepainter)
        props.IntegrationSettings.DatasourceSettings[aIdentifier] = aValue
        SetReady()
    }

    const SetReady = () => 
    {
        props.OnSetReady(!IsEmptyString(props.IntegrationSettings.DatasourceSettings.BlobName))
    }

    const OnFileChange = async (evt) => 
    {        
        SetError("")
        SetProgressMessage("");
        UpdateDatasourceSetting("BlobName","")

        const SelectedFile = evt.target.files[0]

        SetFilename(SelectedFile ? SelectedFile.name : Translate("No file chosen"))
        if (!SelectedFile) 
        {
            return
        }

        //Get a secure temporary upload URL
        SetProgressMessage(Translate("Retrieving secure update link"))
        const BlobSasUriRecord = await ConfigurationApiBlobSasUri(props.SecurityToken);
        if (!BlobSasUriRecord) 
        {
            SetError(Translate("Failed to retrieve secure upload link"))
            return
        }

        try
        {
            //Use the secure upload URL to upload the file            
            SetProgressMessage(Translate("Uploading file"))
            await UploadFileWithProgress(SelectedFile, BlobSasUriRecord.Uri, SetProgressMessage)    
            UpdateDatasourceSetting("BlobName",BlobSasUriRecord.BlobName)
            SetProgressMessage(Translate("File upload ok"))
        }
        catch (ex)
        {
            SetError(Translate("Failed to upload file"))
        }      
    }

    const BrandingId = sessionStorage.getItem("BrandingId")

    return (
        <div className="scriptitembody">            
            <input ref={mFileInputRef} type="file" accept=".csv,.txt,.dat" style={{ display: 'none' }} onChange={OnFileChange}/> 
            <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => mFileInputRef.current?.click()}>{Translate("Choose file")}</Button> <span style={{ marginLeft: "6px"}}>{mFilename}</span>
            {!IsEmptyString(mError) ? <>
                <br/>
                <span className="errortext">{mError}</span>
            </> : 
            (!IsEmptyString(mProgressMessage) ? <>
                <br/>
                <span style={{ color: "green"}}>{mProgressMessage}</span>
            </> : <></>)}
        </div>
    );
}

DatasourceCsvFileExport.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceCsvFileExport